export const USER_PROFILE_TEST_IDS = {
  firstNameInput: 'user-profile__first-name-input',
  lastNameInput: 'user-profile__last-name-input',
  emailInput: 'user-profile__email-input',
  resetPasswordButton: 'user-profile__reset-password-button',
  receiveFeatureEmailsCheckbox: 'user-profile__receive-feature-emails-checkbox',
  receiveDocumentEmailsCheckbox: 'user-profile__receive-document-emails-checkbox',
  saveButton: 'user-profile__save-button',
} as const;
